<template>
    <div class="aba-cliente">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="vertical-flow">
            <div class="columns">
                <!-- CAIXA DE BUSCA -->
                <div
                    class="column"
                    :class="[
                        permissaoVincular && permissaoCadastrar
                            ? 'is-4'
                            : permissaoVincular || permissaoCadastrar
                            ? 'is-6'
                            : 'is-8',
                    ]"
                >
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-campanha"
                    />
                </div>

                <!-- SELEÇÃO DE SITUAÇÃO -->
                <div
                    class="column"
                    :class="[
                        permissaoVincular && permissaoCadastrar
                            ? 'is-2'
                            : permissaoVincular || permissaoCadastrar
                            ? 'is-3'
                            : 'is-4',
                    ]"
                >
                    <vss-select
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        mlLabels
                        title="situacao"
                        clearable
                        @input="onSituacaoChanged"
                        :height="40"
                    />
                </div>

                <!-- BOTÃO DE VINCULAR -->
                <div class="column is-3" v-if="permissaoVincular">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalCampanhaNaoAssociados"
                    >
                        {{ $t("vincular-campanha") }}
                    </button>
                </div>

                <!-- BOTÃO DE ADICIONAR -->
                <div class="column is-3" v-if="permissaoCadastrar">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="$router.push({ 
                            name : `${abrev}-campanha-new`, 
                            query: { 
                                tela: 'cliente-campanha', 
                                'id': $route.params.id, 
                                dadoscadastrais: $route.query.dadoscadastrais 
                                    ? $route.query.dadoscadastrais
                                    : null,
                                politicacomercial: 2,
                                analisecomercial: $route.query.analisecomercial 
                                    ? $route.query.analisecomercial
                                    : null,
                                contexto: isVenda ? 'ven' : 'agro'
                            },
                        })"
                    >
                        {{ $t("adicionar-campanha") }}
                    </button>
                </div>
            </div>

            <!-- LISTAGEM -->
            <div class="registry-wrapper">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="asscampanhacliente"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <!-- COLUNA DE DESATIVAÇÃO/REATIVAÇÃO -->
                        <div v-if="f.key == 'excluir'">
                            <b-button
                                v-if="
                                    permissao.update &&
                                    !assCampanhaClienteIntegracao
                                "
                                class="action-button"
                                :type="
                                    props.row['replicapda'] == 3
                                        ? 'is-danger'
                                        : 'is-success'
                                "
                                :icon-right="
                                    props.row['replicapda'] == 3
                                        ? 'delete'
                                        : 'check'
                                "
                                @click="promptChangeSituacao(props.row)"
                                v-tippy 
                                :title="$t(
                                    props.row['replicapda'] == 3
                                        ? 'desativar'
                                        : 'reativar'
                                )"
                            />
                        </div>

                        <!-- COLUNA DE DATA -->
                        <div v-else-if="f.key == 'data-hora'">
                            {{
                                props.row[f.key] | moment("DD/MM/YYYY HH:mm:ss")
                            }}
                        </div>

                        <!-- COLUNA DE SITUAÇÃO -->
                        <div v-else-if="f.key == 'replicapda'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                :type="
                                    props.row['replicapda'] == 3
                                        ? 'is-success'
                                        : 'is-danger'
                                "
                                size="is-medium"
                            >
                                {{
                                    $t(
                                        props.row["replicapda"] == 3
                                            ? "ativo"
                                            : "inativo"
                                    )
                                }}
                            </b-tag>
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>

                <!-- PAGINAÇÃO -->
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIAÇÃO -->
            <b-modal :active.sync="showModalAssociacao">
                <div class="bg">
                    <CampanhaModal
                        :idCliente="$route.params.id"
                        @fecharModal="fecharModal"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
// SERVICES
import AssCampanhaClienteService from "@/services/vendas/cliente/abas/AssCampanhaClienteService";

// COMPONENTS
import CampanhaModal from "@/components/vendas/cliente/modal/CampanhaModal.vue";
import ContainerLoader from "@/components/content/loader/ContainerLoader";

export default {
    components: {
        ContainerLoader,
        CampanhaModal,
    },
    data() {
        return {
            assCampanhaClienteIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes(
                    "ASSCAMPANHACLIENTE"
                ),
            campanhaIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("CAMPANHA"),
            asscampanhacliente: [],
            fields: [
                { key: "codigo", width: 90, sortable: true, sortFn: null },
                { key: "campanha", width: null, sortable: true, sortFn: null },
                {
                    key: "data-validade",
                    width: 170,
                    sortable: true,
                    sortFn: null,
                },
                { key: "replicapda", width: 80, sortable: true, sortFn: null },
                { key: "excluir", width: 20, sortable: false, sortFn: null },
            ],
            service: new AssCampanhaClienteService(this.$http, this.$router),
            permissao: false,
            permissaoUsuario: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacaoSelected: { id: 4, label: "todos" },
            situacaoSelect: [
                { id: 4, label: "todos" },
                { id: 3, label: "ativos" },
                { id: 2, label: "inativos" },
            ],
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: "",
            column: "campanha",
            order: "asc",
            isSaving: false,
            delete: null,
            showModalAssociacao: false,
            permissaoCadastroCampanha: false,

            //permissões relativas à exibição dos botões
            permissaoVincular: false,
            permissaoCadastrar: false,

            // @86308 - Rota dinâmica abreviando o contexto
            abrev: this.$route.meta.contexto.slice(0,3),
            isVenda: this.$route.meta.contexto == "vendas",
            isAgro: this.$route.meta.contexto == "agro",
        };
    },
    created() {
        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.hasPermissionAccess(
            "vendas",
            "clientes",
            "ven-cliente-politica-comercial-campanha"
        );

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                "vendas",
                "clientes",
                "ven-cliente-politica-comercial-campanha"
            );
            this.permissaoCadastroCampanha = this.hasPermissionAccess(
                "vendas",
                "clientes",
                "ven-campanha"
            );
        }else if(this.isAgro){
            this.abrev = this.$route.meta.contexto.slice(0,4);
            this.permissao = this.hasPermissionAccess( 
                'agro', 
                'clientes', 
                'agro-cliente-politica-comercial-campanha'
            );
            this.permissaoCadastroCampanha = this.hasPermissionAccess( 
                'agro', 
                'clientes', 
                'agro-campanha'
            );
        }

        // variáveis que definem as permissões com base nas permissões da tela e dos dados que vêm do ERP
        this.permissaoVincular =
            this.permissao.create && !this.assCampanhaClienteIntegracao;
        this.permissaoCadastrar =
            this.permissaoCadastroCampanha.create && !this.campanhaIntegracao;

        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "clientes" },
            });
        } else {
            this.carregarDados();
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + "-campanha-" + numberId;
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacaoSelected.id,
                    this.$route.params.id,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.asscampanhacliente = value;
                    this.isEmpty = this.asscampanhacliente.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-load");
                    console.error("Erro ao carregar campanhas.");
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        findAll(column, order, page, limit, situacao, idcliente, ...params) {
            if(this.isVenda) {
                return this.service
                .findAllVendas(column, order, page, limit, situacao, idcliente, ...params);
            }else {
                return this.service
                .findAllAgro(column, order, page, limit, situacao, idcliente, ...params);
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idAssCampanhaCliente: m.idAssCampanhaCliente,
                    codigo: m.campanha.idcampanhaerp,
                    campanha: m.campanha.descricao,
                    "data-validade": this.$moment(
                        m.campanha.datavalidade
                    ).format("DD/MM/YYYY"),
                    replicapda: m.replicapda,
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.replicapda == 3
                        ? "msg-confirmacao-desativacao-n"
                        : "msg-confirmacao-reativacao-n", 
                    { n: row["campanha"] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.replicapda == 3
                    ? "msg-erro-ao-desativar-associacao-campanha"
                    : "msg-erro-ao-reativar-associacao-campanha";

            let tempAsscampanhacliente = {
                idAssCampanhaCliente: this.delete.idAssCampanhaCliente,
                replicapda: this.delete.replicapda == 3 ? 2 : 3,
            };

            this.isLoading = true;

            this.updateSituacao(tempAsscampanhacliente)
                .then((r) => {
                    if (r.status == 200) {
                        console.log(r);
                        let tempSuccess =
                            r.replicapda == 3
                                ? "msg-sucesso-ao-reativar-associacao-campanha"
                                : "msg-sucesso-ao-desativar-associacao-campanha";
                        this.$root.showMessage("success", tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage(
                            "error",
                            "Erro ao atualizar status."
                        );
                    }
                })
                .catch((e) => {
                    console.error("Erro ao atualizar status.", e);
                    this.$root.showMessage("error", tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        updateSituacao(asscampanhacliente) {
            if(this.isVenda) return this.service.updateSituacaoVendas(asscampanhacliente);
            else return this.service.updateSituacaoAgro(asscampanhacliente);
        },
        redirect() {
            this.$router.push(
                {
                    name: `${abrev}-campanha-new`,
                    query: {
                        tela: "cliente-usuario",
                        "id": this.$route.params.id,
                        dadoscadastrais: this.$route.query.dadoscadastrais 
                            ? this.$route.query.dadoscadastrais
                            : null,
                        politicacomercial: 2,
                        analisecomercial: this.$route.query.analisecomercial
                            ? this.$route.query.analisecomercial
                            : null
                    },
                },
                1000
            );
        },
        showModalCampanhaNaoAssociados() {
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        fecharModal() {
            this.showModalAssociacao = false;
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-cliente {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.4rem;
        }
        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>